import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareOnboardingGetStartedRoute: InvariantJiraRoute = {
	name: 'software-onboarding-get-started',
	path: '/jira/software/projects/:projectKey/get-started',
	exact: true,
};
